import { render, staticRenderFns } from "./StepUploadCover.vue?vue&type=template&id=4ee6f3f2&scoped=true"
import script from "./StepUploadCover.vue?vue&type=script&lang=js"
export * from "./StepUploadCover.vue?vue&type=script&lang=js"
import style0 from "./StepUploadCover.vue?vue&type=style&index=0&id=4ee6f3f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee6f3f2",
  null
  
)

export default component.exports